import { render } from "../../templates/partner-cart-prompt-partners.html?vue&type=template&id=5bd62eb6"
import script from "./prompt-partners.vue?vue&type=script&lang=js"
export * from "./prompt-partners.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/lbr.ru/crm/vue_source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__